import { render, staticRenderFns } from "./ScreeningMenu.vue?vue&type=template&id=2648a90a&scoped=true&"
import script from "./ScreeningMenu.vue?vue&type=script&lang=js&"
export * from "./ScreeningMenu.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningMenu.vue?vue&type=style&index=0&id=2648a90a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2648a90a",
  null
  
)

export default component.exports